import { Autocomplete as MuiAutocomplete, AutocompleteProps } from '@mui/material';

export const Autocomplete = ({
  ...props
}: AutocompleteProps<string, boolean, boolean, boolean>) => {
  return <MuiAutocomplete {...props} />;
};
